module.exports = __webpack_public_path__ + "stylesheets/video-player_4059616200137a40bff5ecf396d8cdb9.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/video-player.less
// module id = pbA1
// module chunks = 154